import FingerprintJS from "@fingerprintjs/fingerprintjs";

export const getDeviceID = async () => {
    const fp = await FingerprintJS.load()
    const result = await fp.get();   
    return result.visitorId
}


export const getFormattedTime = (lastSeen, isLastSeen = false) => {
    if (!lastSeen) return '';
    
    if (lastSeen === '-1') {
        return 'online';
    }

    try {
        const timestamp = typeof lastSeen === 'string' ? parseInt(lastSeen) : lastSeen;
        const date = new Date(timestamp);
        
        if (isNaN(date.getTime())) {
            return '';
        }
        const now = new Date();
        const diffInSeconds = Math.floor((now - date) / 1000);
        const diffInMinutes = Math.floor(diffInSeconds / 60);
        const diffInHours = Math.floor(diffInMinutes / 60);
        const diffInDays = Math.floor(diffInHours / 24);

        const timeString = date.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        });

        if (!isLastSeen) {
            return date.toLocaleString([], { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone });
        }

        if (diffInSeconds < 60) {
            return 'last seen just now';
        }

        if (date.getDate() === now.getDate() &&
            date.getMonth() === now.getMonth() &&
            date.getFullYear() === now.getFullYear()) {
            return `last seen today at ${timeString}`;
        }

        const yesterday = new Date(now);
        yesterday.setDate(yesterday.getDate() - 1);
        if (date.getDate() === yesterday.getDate() &&
            date.getMonth() === yesterday.getMonth() &&
            date.getFullYear() === yesterday.getFullYear()) {
            return `last seen yesterday at ${timeString}`;
        }

        if (diffInDays < 7) {
            const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            return `last seen ${days[date.getDay()]} at ${timeString}`;
        }

        return `last seen on ${date.toLocaleDateString([], { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone })} at ${timeString}`;

    } catch (error) {
        console.error('Error formatting last seen date:', error);
        return '';
    }
};

export const getFormattedDeliveryTime = (timestamp) => {
    if (timestamp === 0) return '----';

    try {
        const timeValue = typeof timestamp === 'string' ? parseInt(timestamp) : timestamp;
        const date = new Date(timeValue);

        if (isNaN(date.getTime())) return '';

        const now = new Date();
        const diffInSeconds = Math.floor((now - date) / 1000);
        const timeString = date.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        });

        // Today case
        if (date.getDate() === now.getDate() &&
            date.getMonth() === now.getMonth() &&
            date.getFullYear() === now.getFullYear()) {
            return `Today at ${timeString}`;
        }

        // Yesterday case
        const yesterday = new Date(now);
        yesterday.setDate(yesterday.getDate() - 1);
        if (date.getDate() === yesterday.getDate() &&
            date.getMonth() === yesterday.getMonth() &&
            date.getFullYear() === yesterday.getFullYear()) {
            return `Yesterday at ${timeString}`;
        }
        return `${date.toLocaleDateString([], { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone })} at ${timeString}`;

    } catch (error) {
        console.error(`Error formatting date:`, error);
        return '';
    }
};

export const debounce = (func, time) => {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, time);
    };
}

export const parseMessageWithLink = (message = '') => {
    if (!message) return { text: '', url: '' };

    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const match = urlRegex.exec(message);

    if (match) {
        // Get the URL
        const url = match[0];

        // Get the text without the URL
        const textBeforeUrl = message.substring(0, match.index);
        const textAfterUrl = message.substring(match.index + url.length);
        const text = textBeforeUrl + textAfterUrl;

        return { text: text.trim(), url };
    }

    return { text: message, url: '' };
};

export const generateProfileImageByInitials = (name, height = 100, width = 100, fillColor = '#7062E9', textColor = '#ffffff') => {
  const canvas = document.createElement('canvas')
  canvas.width = width;
  canvas.height = height;

  const ctx = canvas.getContext('2d')
  ctx.fillStyle = fillColor;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.font = 'bold 40px Arial';
  ctx.fillStyle = textColor;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';

  let initials = '';
    const nameParts = name?.trim()?.split(' ');

    if (nameParts?.length >= 2) {
      initials = nameParts?.[0]?.[0].toUpperCase() + nameParts?.[1]?.[0].toUpperCase();
    } else if (nameParts?.length === 1) {
      initials = nameParts?.[0]?.slice(0, 1)?.toUpperCase();
  }

  ctx.fillText(initials, canvas.width / 2, canvas.height / 2);

  return canvas.toDataURL();
}
function deleteCookie(cookieName) {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }
export const clearAll=() =>{
    deleteCookie('userToken');
    deleteCookie('isometrikUserId');
    localStorage.removeItem('preferred-theme');
    const url = new URL(window.location.href);
    url.searchParams.delete('conversation');
    window.history.pushState({}, '', url.toString());
    window.location.reload();
}
export const convertSecondsToMinutes = (seconds) => {
    try {
      let minutes = Math.floor(seconds / 60);
      let remainingSeconds = seconds % 60;
      if (minutes < 10) {
        minutes = `0${minutes}`
      }
      if (remainingSeconds < 10) {
        remainingSeconds = `0${remainingSeconds}`
      }
      return `${minutes}:${remainingSeconds}`;
    } catch (error) {
    }
  }

  export const getGroupcastUrlQuery =  () =>{
    const urlParams = new URLSearchParams(window.location.search);
    const isGroupcast = urlParams.has('groupcast');
    const groupcastId = urlParams.get('groupcast');
    return { isGroupcast, groupcastId };
  }
export default { getDeviceID, getFormattedTime, debounce, parseMessageWithLink, generateProfileImageByInitials, getFormattedDeliveryTime,convertSecondsToMinutes, getGroupcastUrlQuery }